import React, {Component, useEffect, useState} from "react";
import {CheckMember} from './fetch.js';
import Autocomplete from '@material-ui/lab/Autocomplete';

import {
    Avatar, Box, Button, Checkbox,
    Container, createMuiTheme,
    CssBaseline,
    FormControlLabel,
    Grid, Hidden, Link,
    makeStyles, Modal,
    TextField,
    Typography
} from "@material-ui/core";
import {Copyright} from "@material-ui/icons";

const theme = createMuiTheme();

/*
let MainContainer = {
    position: 'absolute',
    background: 'white',
    top: '2em',
    left: '2em',
    bottom: '2em',
}
*/

const paper = {
    marginTop: '20px',
    // marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
}
const avatar = {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
}
const form = {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
}
const submit = {
    margin: theme.spacing(3, 0, 2),
}

const countryToFlag = (isoCode) => {
    return typeof String.fromCodePoint !== 'undefined'
        ? isoCode
            .toUpperCase()
            .replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
        : isoCode;
}

export default class MemberEditForm extends React.PureComponent {

    ModalLabel = {
        fontSize: '1.5rem',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: '400',
        lineHeight: '1.334',
        letterSpacing: '0em',
        margin: '0',
    }

    ModalLabelSmall = {
        fontSize: '1.2rem',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: '400',
        lineHeight: '1.334',
        letterSpacing: '0em',
        margin: '0',
    }

    ModalBody = {
        backgroundColor: 'white',
        width: '25vw',
        marginLeft: 'auto',
        marginRight: 'auto',
        left: '0',
        right: '0',
        textAlign: 'center',
        position: 'absolute',
        top: '33%',
        padding: '10px',
    }

    MainContainer = {
        position: 'absolute',
        background: 'white',
        top: '2em',
        left: '2em',
        bottom: '2em',
    }


    constructor(props) {
        super(props);
        this.state = {
            memberId: '',
            memberEmail: '',
            isShowBadAuthModal: false,
            isShowTbSfn: false,
        };

    }

    getData = (actionName, data, successCallback, errorCallback) => {
        CheckMember(
            actionName,
            data,
            (result) => {
                successCallback(result);
            },
            (error) => {
                errorCallback(error);
            });
    }

    badAuthModalClosed(newValue) {

        if (newValue == 'escapeKeyDown' || newValue == 'backdropClick') {

            this.setState(
                prevState => {
                    const {isShowBadAuthModal: prevIsShowBadAuthModal} = prevState;
                    return {
                        isShowBadAuthModal: false,
                    };
                },
                () => {
                    // this.setSomeOtherState();
                }
            );

        }

    }

    showBadAuthModal() {

        this.setState(
            prevState => {
                const {isShowBadAuthModal: prevIsShowBadAuthModal} = prevState;
                return {
                    isShowBadAuthModal: true,
                };
            },
            () => {
                // this.setSomeOtherState();
            }
        );

    }

    closeBadAuthModal(element) {
        this.setState(
            prevState => {
                const {isShowBadAuthModal: prevIsShowBadAuthModal} = prevState;
                return {
                    isShowBadAuthModal: false,
                };
            },
            () => {
                // this.setSomeOtherState();
            }
        );

    }

    submitRegistration(newValue) {

        newValue.preventDefault();

        debugger;
        this.getData('getEditMemberUrl', {memberId: this.state.memberId, memberEmail: this.state.memberEmail},
            (result) => {
                debugger;
                if (result.data) {
                    // const memberDetailsForm = document.getElementById('memberDetailsForm');
                    // this.state.userDetails = result.data;

                    window.location.href = result.data[0].Column1;

                    debugger;

                    // memberDetailsForm.setAttribute('action', 'https://kenes.eventsair.com/KenesSiteRedirect/fens2021/fensredirect/contactpost/data');
                    // memberDetailsForm.submit();
                } else {
                    this.showBadAuthModal();
                }
            },
            (error) => {
                debugger;
                this.showBadAuthModal();
            }
        );
    }

    onWindowResize = () => {
        if (window.innerWidth < 500 || window.innerHeight < 500) {
            this.MainContainer = {
                position: 'unset',
                background: 'white',
                top: '2em',
                left: '2em',
                bottom: '2em',
            }
            this.ModalBody = {
                backgroundColor: 'white',
                width: '77vw',
                marginLeft: 'auto',
                marginRight: 'auto',
                left: '0',
                right: '0',
                textAlign: 'center',
                position: 'absolute',
                top: '33%',
                padding: '10px',
            }

        }
    }

    render() {

        window.addEventListener('resize', this.onWindowResize, false);

        if (window.innerWidth < 500 || window.innerHeight < 500) {
            this.MainContainer = {
                position: 'unset',
                background: 'white',
                top: '2em',
                left: '2em',
                bottom: '2em',
            }
            this.ModalBody = {
                backgroundColor: 'white',
                width: '77vw',
                marginLeft: 'auto',
                marginRight: 'auto',
                left: '0',
                right: '0',
                textAlign: 'center',
                position: 'absolute',
                top: '33%',
                padding: '10px',
            }
        }

        return (
            <Container style={this.MainContainer} component="main" maxWidth="xs">
                <CssBaseline/>
                <img style={{width: '50%', marginTop: '10px'}}
                     src={"https://forum.fens.org/wp-content/uploads/sites/129/2018/07/logo-white-bg-new1.png"}/>
                <div style={paper}>
                    <Avatar style={avatar}>
                        {/*<LockOutlinedIcon/>*/}
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Register
                    </Typography>
                    <form id="memberEditForm" style={form}
                          onSubmit={(element) => {
                              this.submitRegistration(element);
                          }}
                    >

                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    id="memberId"
                                    name="memberId"
                                    onChange={(element) => {
                                        this.tbMemberIdChanged(element);
                                    }}
                                    autoComplete="memberId"
                                    variant="outlined"
                                    required
                                    fullWidth
                                    label="Member Id"
                                    autoFocus
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="memberEmail"
                                    name="memberEmail"
                                    onChange={(element) => {
                                        this.tbMemberEmailChanged(element);
                                    }}
                                    variant="outlined"
                                    required
                                    fullWidth
                                    label="Member Email"
                                    autoComplete="email"
                                />
                            </Grid>
                            {/*<Grid item xs={12}>
                                <FormControlLabel
                                    control={<Checkbox value="allowExtraEmails" color="primary"/>}
                                    label="I want to receive inspiration, marketing promotions and updates via email."
                                />
                            </Grid>*/}
                        </Grid>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            style={submit}
                        >
                            Submit
                        </Button>
                        {/*<Grid container justify="flex-end">
                            <Grid item>
                                <Link href="#" variant="body2">
                                    Already have an account? Sign in
                                </Link>
                            </Grid>
                        </Grid>*/}
                    </form>
                </div>
                <Modal
                    open={this.state.isShowBadAuthModal}
                    onClose={(event, newValue) => {
                        this.badAuthModalClosed(newValue);
                    }}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                >
                    <div style={this.ModalBody}>
                        {/*<img style={{width: '50%', marginTop: '10px'}}
                             src={"https://forum.fens.org/wp-content/uploads/sites/129/2018/07/logo-white-bg-new1.png"}/>*/}
                        <table style={{width: '100%',}}>
                            <tr>
                                <td colspan={2}>
                                    <p style={this.ModalLabel}>Member Id and Email dont match</p>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    <br/>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    <p style={this.ModalLabelSmall}>Please try again</p>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    <br/>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={(element) => {
                                            this.closeBadAuthModal(element);
                                        }}
                                    >
                                        Ok
                                    </Button>
                                </td>
                            </tr>
                        </table>
                    </div>
                </Modal>
                {/*<Box mt={5}>
                    <Copyright/>
                </Box>*/}
            </Container>
        );
    }

    tbMemberIdChanged(newValue) {

        if (newValue == null) {
            return;
        }
        this.setState(
            prevState => {
                const {memberId: prevIsShow} = prevState;
                return {
                    memberId: newValue.target.value,
                };
            },
            () => {
                // this.setSomeOtherState();
            }
        );
    }

    tbMemberEmailChanged(newValue) {

        if (newValue == null) {
            return;
        }
        this.setState(
            prevState => {
                const {memberEmail: prevIsShow} = prevState;
                return {
                    memberEmail: newValue.target.value,
                };
            },
            () => {
                // this.setSomeOtherState();
            }
        );
    }

}

// export default RegistrationForm;
